import { Routes } from 'config/routes';
import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import RecruiterDashboard from '../../components/RecruiterDashboard';
import { useRecruiterDashboardAccess } from '../../hooks/useRecruiterDashboardAccess';

const RecruiterDashboardPage: FC = () => {
  const { t } = useTranslation('dashboard.RecruiterDashboard');
  const navigate = useNavigate();
  const { hasAccess, loading } = useRecruiterDashboardAccess();

  // Redirect to home if user doesn't have access
  useEffect(() => {
    if (!loading && !hasAccess) {
      navigate(Routes.Profile, { replace: true });
    }
  }, [hasAccess, loading, navigate]);

  // Don't render anything while checking access or if no access
  if (loading || !hasAccess) {
    return null;
  }

  return (
    <ProfileSideMenuWrapper title={t('title')}>
      <RecruiterDashboard />
    </ProfileSideMenuWrapper>
  );
};

export default RecruiterDashboardPage;
